import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import VehicleType from '@/models/vehicleTypeModel'
import { RepositoryFactory, Repositories } from '../repositories/repositoryFactory'
import Vue from 'vue'

@Module({})
export default class vehicleTypeModule extends VuexModule {
  // Data
  types: Array<VehicleType> = []

  @Action({})
  fetchTypes (): Promise<any> {
    const vm = this

    // if (this.types.length > 0) {
    //   vm.context.commit('setTypes', this.types.map((type) => {
    //     const newType = new VehicleType().convertFromObject(type)
    //     return newType
    //   }))
    //   return Promise.resolve(this.types)
    // }

    return RepositoryFactory.get(Repositories.Vehicle).getTypes().then(function (result: any) {
      vm.context.commit('setTypes', result)
      return result
    })
  }

  get vehicleType (): any {
    return this.types
  }

  // Mutations
  @Mutation
  setTypes (types: Array<VehicleType>) {
    this.types = types
  }
}
